<div class="upgrade-dialog">
    <i
        class="dr-icon dr-icon-exit upgrade-dialog__close"
        (click)="close()"
        aria-label="Close"
        role="button"
        tabindex="0"
    ></i>
    <div class="upgrade-dialog__illustration">
        <img [src]="illustrationUrl" alt="FinanceOS" class="upgrade-dialog__illustration__img" />
    </div>
    <div class="upgrade-dialog__content">
        <div class="upgrade-dialog__title">Upgrade to FinanceOS</div>
        <div class="upgrade-dialog__subtitle">The foundation of modern finance</div>
        <div class="upgrade-dialog__description">
            Ready to connect your real data and get answers for your business? Our team can help you get set up and hit
            the ground running.
        </div>
        <div class="upgrade-dialog__action">
            <a
                class="upgrade-dialog__button"
                href="https://www.datarails.com/request-a-demo/"
                target="_blank"
                rel="noopener noreferrer"
            >
                Upgrade to FinanceOS
            </a>
        </div>
    </div>
</div>
